import TableTemplate from "../../TableTemplate/tableTemplate";
import { CommonTableUI } from "../../TableTemplate/common";
import {
  IDeltaProccessSahraOrderSearchParam,
  IDetailProcessSahraOrderReport,
} from "../../../Interfaces/deltaHedgeExe";
import { getSahraOrders } from "../../../Requests/deltaHedgeExe";

interface IProps {
  searchParams: IDeltaProccessSahraOrderSearchParam;
}

const SahraOrdersTable = ({ searchParams }: IProps) => {
  return (
    <TableTemplate<IDeltaProccessSahraOrderSearchParam, IDetailProcessSahraOrderReport>
      TableUI={({ reports, onAction }) => (
        <CommonTableUI reports={reports} onAction={onAction} />
      )}
      getDataTable={getSahraOrders}
      searchParameters={searchParams}
    />
  );
};

export default SahraOrdersTable;
